import NanobarWrapper from "./NanobarWrapper";

/**
 * The one loading bar along the top of the screen, and everything it tracks.
 *
 * Every API call drives it by default, and so does anything else big enough to
 * be waited on. When it moved only for the requests a caller remembered to hand
 * it, most of what the app downloads (a cell's history, a storm's volume, the 3D
 * map's library, a place name) happened with nothing on screen to say so.
 *
 * Made on first use, not at import: nanobar builds its element in the page,
 * and the tests import modules that import this one without a page to build in.
 */
let bar: NanobarWrapper | null = null;

export function progress(): NanobarWrapper {
  bar ??= new NanobarWrapper();
  return bar;
}

/**
 * Run a download with the bar moving until it is done, body and all.
 *
 * Each download is a step, so a batch of volumes fills the bar as it lands
 * rather than jumping to the end; a finish only counts against a start under
 * the same `id`.
 */
export async function tracked<T>(id: string, work: () => Promise<T>): Promise<T> {
  const shown = progress();
  shown.start(id);
  try {
    return await work();
  } finally {
    shown.finish(id);
  }
}
